import axios from '../../axios'

/*
 * 材料数据接口
 */
// 获取爬虫网站分页列表
export const getWebsiteList = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website/page',
        method: 'get',
        data
    })
}

// 网站id查询
export const getWebsiteId = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website/get',
        method: 'get',
        data
    })
}
// 网站新增
export const addWebsite = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website',
        method: 'post',
        data
    })
}

// 网站更新
export const updateWebsite = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website',
        method: 'put',
        data
    })
}

// 网站删除
export const deleteWebsite = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website',
        method: 'delete',
        data
    })
}
// 网站测试
export const testWebsite = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website/test',
        method: 'post',
        data
    })
}
// 网站html测试
export const testHtmlWebsite = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website/html/test',
        method: 'post',
        data
    })
}
// 网站配置测试
export const testSetup = (data) => {
    return axios({
        url: '/api/base/admin/crawler/website/setup/test',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/reptile/website.js